module.exports = __webpack_public_path__ + "static/Kultur_Erholung-b86b1db5d2e6a31d41c1e26433a6de40.png";